import Storage from "storejs";
import { AMT } from "./AMT";
//import validateFormatted from "mapbox-gl/src/style-spec/validate/validate_formatted";

/**
 * Created by yangpengju on 2018/5/28.
 */
/* eslint-disable */
var BTools = {
  security: {
    ckr: function(roleName) {
      let userRoles = Storage.get("userRoles");
      let hasRoles = roleName.split(",");
      if (userRoles) {
        for (let i in userRoles) {
          for (let j in hasRoles) {
            if (userRoles[i].name === hasRoles[j]) {
              return true;
            }
          }
        }
      }
      return false;
    },
    ckp: function(permission) {
      let userPermissions = Storage.get("userPermissions");
      if (userPermissions) {
        if (permission) {
          for (let i in userPermissions) {
            if (userPermissions[i].permission_value === permission) {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
  check: {
    isTargetType: function(obj, typeString) {
      if (typeString === "undefined") {
        return typeof obj === "undefined";
      } else if (typeString === "object") {
        return typeof obj === "object";
      } else if (typeString === "boolean") {
        return typeof obj === "boolean";
      } else if (typeString === "number") {
        return typeof obj === "number";
      } else if (typeString === "string") {
        return typeof obj === "string";
      } else if (typeString === "function") {
        return typeof obj === "function";
      } else if (typeString === "symbol") {
        return typeof obj === "symbol";
      }
    },
    isFunction: function(obj) {
      return this.isTargetType(obj, "function");
    },
    isIntValue: function(value) {
      if (value === "") {
        return false;
      }
      if (!/(^[1-9]\d*$)/.test(value)) {
        return false;
      } else {
        return true;
      }
    }
  },
  string: {
    trim: function(str) {
      if (str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
      } else {
        return str;
      }
    },
    isNullOrEmpty: function(str) {
      return !!(str == null || str === undefined || this.trim(str) === "");
    },
    findInSet: function(str, set) {
      if (this.isNullOrEmpty(str) || this.isNullOrEmpty(set)) {
        return false;
      } else {
        let flag = false;
        let setArray = set.split(",");
        for (let i in setArray) {
          if (this.trim(str) === this.trim(setArray[i])) {
            flag = true;
          }
        }
        return flag;
      }
    },
    /**
     * 驼峰命名法工具
     * camelCase("hello_world") == "helloWorld"
     * @param str
     */
    camelCase: function(str) {
      let strArray = str.split("_");
      let camelStr = "";
      for (let i in strArray) {
        camelStr +=
          strArray[i].substr(0, 1).toUpperCase() + strArray[i].substr(1);
      }
      return camelStr;
    }
  },
  math: {
    /**
     * 加法
     * @param data1 被加数
     * @param data2 加数
     * @returns {number} 结果
     */
    add: function(data1, data2) {
      let r1, r2, m;
      // 获取每个参数的小数的位数
      try {
        r1 = data1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = data2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      // 计算底数为10以最大小数位数为次幂的值
      m = Math.pow(10, Math.max(r1, r2));
      // 把所有参数转为整数后相加再除以次幂的值
      return (data1 * m + data2 * m) / m;
    },
    /**
     * 减法
     * @param data1 被减数
     * @param data2 减数
     * @returns {string} 结果
     */
    sub: function(data1, data2) {
      let r1, r2, m, n;
      // 获取每个参数的小数的位数
      try {
        r1 = data1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = data2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      // 计算底数为10以最大小数位数为次幂的值
      m = Math.pow(10, Math.max(r1, r2));
      // 精度长度以最大小数位数为长度
      n = r1 >= r2 ? r1 : r2;
      return ((data1 * m - data2 * m) / m).toFixed(n);
    },
    /**
     * 乘法
     * @param data1 被乘数
     * @param data2 乘数
     * @returns {number} 结果
     */
    mul: function(data1, data2) {
      let m = 0;
      let s1 = data1.toString();
      let s2 = data2.toString();
      // 获取所有参数小数位长度之和
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      // 替换掉小数点转为数字相乘再除以10的次幂值
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    /**
     * 除法
     * @param data1 被除数
     * @param data2 除数
     * @returns {number} 结果
     */
    div: function(data1, data2) {
      let t1 = 0;
      let t2 = 0;
      let r1, r2;
      // 获取每个参数的小数的位数
      try {
        t1 = data1.toString().split(".")[1].length;
      } catch (e) {}
      try {
        t2 = data2.toString().split(".")[1].length;
      } catch (e) {}
      // 把所有参数的小数点去掉转为整数
      r1 = Number(data1.toString().replace(".", ""));
      r2 = Number(data2.toString().replace(".", ""));
      return (r1 / r2) * Math.pow(10, t2 - t1);
    }
  },
  tree: {
    menuListToTree(list, pid) {
      let menuTree = new Array(0);
      for (let i in list) {
        if (list[i].pid === pid) {
          if (list[i].type === "1") {
            list[i].child = this.menuListToTree(list, list[i].id);
          }
          menuTree.push(list[i]);
        }
      }
      return menuTree;
    },
    listToTree(list, pid, pids) {
      let tree = new Array(0);
      for (let i in list) {
        if (list[i].pid === pid) {
          if (pids) {
            if (BTools.string.findInSet(list[i].id, pids)) {
              list[i].children = this.listToTree(list, list[i].id, pids);
            }
          } else {
            if (list[i].has_child) {
              list[i].children = this.listToTree(list, list[i].id);
            }
          }
          tree.push(list[i]);
        }
      }
      return tree;
    }
  },
  bui: {
    checkOnly(el, form, vo, callback, label) {
      let key;
      let value;
      for (let k in vo) {
        key = k;
        value = vo[k];
      }
      value = BTools.string.trim(value);
      el[form][key] = value;
      if (value === "") {
        return callback(new Error(label + "不能是空白字符串"));
      } else {
        BTools.bos.checkOnly(
          el.$http,
          el.baseUrl,
          el[form].id,
          key,
          value,
          () => {
            return callback(new Error(label + "不唯一"));
          },
          () => {
            return callback();
          }
        );
      }
    }
  },
  bos: {
    /**
     * 查询唯一条件初始化
     * @param name
     * @param value
     * @returns {{page_size: string, page_num: string}}
     */
    initOnlyParams(name, value) {
      let params = {
        page_size: "1",
        page_num: "1"
      };
      params[name] = value;
      return params;
    },
    /**
     * 通过查询数据列表是否有记录来确认唯一
     * @param http
     * @param url
     * @param name
     * @param value
     * @param isNotOnly
     * @param isOnly
     */
    checkOnly(http, url, id, name, value, isNotOnly, isOnly) {
      http
        .get(url, {
          params: this.initOnlyParams(name, value)
        })
        .then(response => {
          if (
            response.data &&
            response.data !== "" &&
            response.data.code === 200
          ) {
            let data = response.data.data;
            if (
              data.length > 0 &&
              data[0].id !== id &&
              BTools.check.isFunction(isNotOnly)
            ) {
              isNotOnly();
            } else {
              if (BTools.check.isFunction(isOnly)) {
                isOnly();
              }
            }
          }
        })
        .catch(function(error) {
          console && console.log("确认" + name + "是否唯一请求错误:", error);
        });
    },
    /**
     * 通过ID查询实体
     * @param el
     * @param url
     * @param id
     * @param params
     * @param success
     * @param fail
     * @param err
     */
    queryById(el, url, id, params, success, fail, err) {
      el.$http
        .get(url + "/" + id, {
          params: params
        })
        .then(response => {
          console && console.log("通过ID查询实体：", response.data);
          if (
            response.data &&
            response.data.data !== "" &&
            response.data.code === 200
          ) {
            let data = response.data.data;
            if (BTools.check.isFunction(success)) {
              success(data);
            }
          } else {
            if (BTools.check.isFunction(fail)) {
              fail(response.data);
            }
          }
        })
        .catch(function(error) {
          console && console.log("通过ID查询实体错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },
    /**
     * 分页查询实体
     * @param el
     * @param url
     * @param params
     * @param success
     * @param fail
     * @param err
     */
    queryPage(el, url, params, success, fail, err) {
      el.$http
        .get(url, {
          params: params
        })
        .then(response => {
          console && console.log("分页查询实体：", response.data);
          if (response.data && response.data.code === 200) {
            let data = response.data;
            if (BTools.check.isFunction(success)) {
              success(data);
            }
          } else {
            if (BTools.check.isFunction(fail)) {
              fail(response.data);
            }
          }
        })
        .catch(function(error) {
          console && console.log("分页查询实体错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },
    /**
     * 通过ID删除实体
     * @param el
     * @param url
     * @param id
     * @param success
     * @param fail
     * @param err
     */
    deleteById(el, url, id, success, fail, err) {
      el.$http
        .post(url + "/delete/" + id)
        .then(response => {
          console && console.log("通过ID删除实体：", response.data);
          if (
            response.data &&
            response.data !== "" &&
            response.data.code === 200
          ) {
            if (BTools.check.isFunction(success)) {
              success();
            }
          } else {
            if (BTools.check.isFunction(fail)) {
              fail(response.data);
            }
          }
        })
        .catch(error => {
          console && console.log("通过ID删除实体错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },
    /**
     * 保存实体
     * @param el
     * @param url
     * @param model
     * @param success
     * @param fail
     * @param err
     */
    save(el, url, model, success, fail, err) {
      el.$http
        .post(url, model)
        .then(response => {
          console && console.log("保存实体：", response.data);
          if (response.data && response.data.code === 201) {
            if (BTools.check.isFunction(success)) {
              success(response.data.data);
            }
          } else {
            if (BTools.check.isFunction(fail)) {
              fail(response.data);
            }
          }
        })
        .catch(error => {
          console && console.log("保存实体错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },
    /**
     * post请求
     * @param el
     * @param url
     * @param params
     * @param success
     * @param err
     */
    post(el, url, params, success, err) {
      el.$http
        .post(url, params)
        .then(response => {
          console && console.log("post请求：", response.data);
          if (response.data) {
            if (BTools.check.isFunction(success)) {
              success(response.data);
            }
          }
        })
        .catch(error => {
          console && console.log("post请求错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },
    /**
     * get请求
     * @param el
     * @param url
     * @param params
     * @param success
     * @param err
     */
    get(el, url, params, success, err) {
      el.$http
        .get(url, {
          params: params
        })
        .then(response => {
          console && console.log("get请求：", response.data);
          if (response.data) {
            if (BTools.check.isFunction(success)) {
              success(response.data);
            }
          }
        })
        .catch(function(error) {
          console && console.log("get请求错误：", error);
          if (BTools.check.isFunction(err)) {
            err(error);
          }
        });
    },

    /**
     * 根据字典类型获取字典数据
     * @param el
     * @param type
     * @param success
     * @param fail
     * @param err
     */
    getDictByType(el, type, success, fail, err) {
      BTools.bos.queryPage(
        el,
        el.$initUrl.api_url + "/upms_dict",
        { type: type },
        success,
        fail,
        err
      );
    }
  },
  date:{
    // 格式化时间
    formatTime(param) {
      const y = param.getFullYear()
      let m = param.getMonth() + 1
      let d = param.getDate()
      m = m < 10 ? ('0' + m) : m
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    /**
     * 以当前时间为基础，便捷获取时间（今天，最近几天（延申昨天、近几周，按天算），最近1月，最近2月，最近半年，最近一年，本周，本月，本年）
     * @param { string } code
     * @param { int } daynum （查天、周：天数；查月：月数；查年）
     * @returns { Object }
     */
    getDate(code,daynum) {
      const date = new Date()
      const endTime = this.formatTime(date)
      const date1 = Date.parse(date)
      let start = ''
      let end = ''
      let a = 0
      const oneDay = 1000 * 3600 * 24

      switch (code) {
          // 今天
        case 'today':
          start = new Date()
          break
          // 最近几天/周
        case 'fewDays':
          start = date1 - oneDay * parseInt(daynum)
          break
          // 最近几月
        case 'fewMonth':
          start = new Date()
          start.setMonth(start.getMonth() - daynum)
          break
          // 最近几年
        case 'fewYear':
          start = new Date()
          start.setYear(start.getFullYear() - daynum)
          break
          // 最近半年
        case 'lastHalfYear':
          start = date1 - oneDay * 183
          break
          // 本周
        case 'thisWeek':
          a = 6 - date.getDay()
          start = new Date(date1 - oneDay * a).setHours(0, 0, 0, 0)
          end = new Date(date1 + oneDay * (1 + date.getDay())).setHours(24, 0, 0, 0)
          break
          // 本月
        case 'thisMonth':
          start = new Date()
          start.setHours(0, 0, 0, 0)
          start.setMonth(start.getMonth(), 1)
          end = new Date(start)
          end.setHours(0, 0, 0, 0)
          end.setMonth(start.getMonth() + 1, 1)
          break
          // 本年
        case 'thisYear':
          start = new Date()
          start.setHours(0, 0, 0, 0)
          start.setMonth(0, 1)
          start.setYear(start.getFullYear())
          end = new Date(start)
          end.setHours(0, 0, 0, 0)
          end.setMonth(start.getMonth(), 1)
          end.setYear(start.getFullYear() + 1)
          break
      }

      return {
        startTime: this.formatTime(new Date(start)),
        endTime: end ? this.formatTime(new Date(end)) : endTime
      }
    }
  },
  fuc: {
    // 解析url参数并获取code
    getUrlParam(name) {
      //name为要获取的参数名
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var rrr = decodeURIComponent(window.location.search);
      var r = rrr.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //删除空值属性
    simplify(obj) {
      if (!obj) {
        return;
      }
      let emptyArr = [];
      for (let m in obj) {
        if (!obj[m]) {
          emptyArr.push(m);
        }
      }
      for (let n in emptyArr) {
        delete obj[emptyArr[n]];
      }
      return obj;
    },
    //获取菜单中文名
    getMenuName(name) {
      let _menudic = Storage.get("menudic") || {};
      if (_menudic) {
        return _menudic[name];
      } else {
        console.log("获取localstorage菜单字典值失败");
      }
    },
    //获取菜单值
    getMenuValue(name) {
      let _menudic = Storage.get("menudic") || {};
      if (_menudic) {
        for (let k in _menudic) {
          if (_menudic[k] == name) {
            return k;
          }
        }
      } else {
        console.log("获取localstorage菜单字典键失败");
      }
    },
    //返回用户功能权限
    getMenuPerm(text) {
      let _perm = Storage.get("userPermissions") || [];
      let _result = false;
      for (let p in _perm) {
        if (p.text == text) {
          _result = p.perm;
        }
      }
      return _result;
    },
    //获取两个集合的交(i)、并(u)、补(c)、差(d)集合
    getArrayItem(operate, min, max) {
      let result = [];
      switch (operate) {
        // 交集
        case "i":
          result = min.filter(function(val) {
            return max.indexOf(val) > -1;
          });
          break;
        // 并集
        case "u":
          result = min.concat(
            max.filter(function(val) {
              return !(min.indexOf(val) > -1);
            })
          );
          break;
        // 补集 两个数组各自没有的集合
        case "c":
          result = min
            .filter(function(val) {
              return !(max.indexOf(val) > -1);
            })
            .concat(
              max.filter(function(val) {
                return !(min.indexOf(val) > -1);
              })
            );
          break;
        // 差集 数组min相对于max所没有的
        case "d":
          result = max.filter(function(val) {
            return min.indexOf(val) === -1;
          });
          break;
      }
      return result;
    },
    //根据属性值长度排序
    compare(pro) {
      return function(a, b) {
        let flen = a[pro].length;
        let slen = b[pro].length;
        return flen - slen;
      };
    },
    //权限状态获取
    getPermState(roleid) {
      //index 已发送列表下标，flag权限状态（0未申请，1已拥有，2审批中）
      let result = { index: -1, flag: 0 };
      let _user = Storage.get("upmsUser");
      let _apply = Storage.get("apply") || [];
      let _roleItem = _user.role_name || "";
      let index = _apply.indexOf(roleid);
      if (_roleItem.indexOf(roleid) > -1) {
        //已拥有
        result.flag = 1;
        result.index = index;
      } else if (index == -1) {
        //未申请
        result.flag = 0;
      } else {
        result.flag = 2;
      }
      return result;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    formatDate(date, fmt) {
      date = new Date(date)
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    getAMTTxt(txt) {
      return AMT(txt);
    }
  },
  OS: {
    //判断操作系统
    isIOS() {
      let u = navigator.userAgent;
      // , app = navigator.appVersion;
      // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    }
  }
};

export default BTools;
